import { render, staticRenderFns } from "./EditProjectGroup.vue?vue&type=template&id=6feaf9a8&scoped=true&"
import script from "./EditProjectGroup.vue?vue&type=script&lang=js&"
export * from "./EditProjectGroup.vue?vue&type=script&lang=js&"
import style0 from "./EditProjectGroup.vue?vue&type=style&index=0&id=6feaf9a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6feaf9a8",
  null
  
)

export default component.exports